module.exports = __webpack_public_path__ + "static/media/exitLeft.8def17b2.svg";